import { http, HttpResponse } from 'msw';
import { contactFactory } from '@trukt/factories/contactFactory';
import { mockTruktTmsApiUrl } from '../mocks';
import {
  SearchTerminalContactsResponse,
  TerminalContactGetResponse,
  CreateTerminalContactResponse,
} from '../services/TerminalService/services/TerminalContactService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/terminals/:terminalGuid/contacts'), () => {
    return HttpResponse.json<SearchTerminalContactsResponse>({
      page: 1,
      rows: 3,
      total: 3,
      results: contactFactory.buildList(3),
    });
  }),
  http.get(mockTruktTmsApiUrl('/terminals/:terminalGuid/contacts/:contactGuid'), () => {
    return HttpResponse.json<TerminalContactGetResponse>(contactFactory.build());
  }),
  http.post(mockTruktTmsApiUrl('/terminals/:terminalGuid/contacts'), () => {
    return HttpResponse.json<CreateTerminalContactResponse>(contactFactory.build());
  }),
  http.patch(mockTruktTmsApiUrl('/terminals/:terminalGuid/contacts/:contactGuid'), () => {
    return HttpResponse.json();
  }),
];
